import {ValueObject} from '@s-ui/domain'

import {InvalidParamsSharedError} from '../../shared/Errors/InvalidParamsSharedError.js'

export class SeoMetaValueObject extends ValueObject {
  #name
  #content

  constructor({name, content}) {
    super()
    this.#name = name
    this.#content = content
  }

  static validate({name, content}) {
    if (!name) throw InvalidParamsSharedError.create('[SeoMetaValueObject] name is required')
    if (!content) throw InvalidParamsSharedError.create('[SeoMetaValueObject] content is required')
  }

  static create({name, content}) {
    SeoMetaValueObject.validate({name, content})
    return new SeoMetaValueObject({name, content})
  }

  get name() {
    return this.#name
  }

  get content() {
    return this.#content
  }

  get value() {
    return {
      name: this.#name,
      content: this.#content
    }
  }
}
